"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.range = void 0;
const ramda_1 = require("ramda");
/**
 * Generates an array of numbers from start value to end value inclusive
 * in ascending or descending order
 *
 * @param start - The first number in the range.
 * @param end - The last number in the range.
 * @returns The array of numbers.
 *
 * @public
 *
 * @example
 * ```ts
 * const result = range(-1, 5);
 * console.log(result);
 * // -> [-1, 0, 1, 2, 3, 4, 5]
 * ```
 */
function range(start, end) {
    return (0, ramda_1.times)((0, ramda_1.ifElse)((0, ramda_1.gt)(ramda_1.__, end), ramda_1.subtract, ramda_1.add)(start), (0, ramda_1.inc)(Math.abs((0, ramda_1.subtract)(start, end))));
}
exports.range = range;
//# sourceMappingURL=range.js.map